import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate } from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { EmploymentAccessDataFetcherService } from '../services/employment-access-data-fetcher.service';
import { EmploymentAccessService } from '../services/employment-access.service';

@Injectable({
  providedIn: 'root',
})
export class ManagedEmploymentGuard implements CanActivate {
  constructor(
    private employmentAccessService: EmploymentAccessService,
    private employmentAccessDataFetcherService: EmploymentAccessDataFetcherService
  ) {}

  canActivate(route: ActivatedRouteSnapshot): Observable<boolean> {
    return this.employmentAccessDataFetcherService
      .fetchManagedEmploymentsAccessData(false, true)
      .pipe(map(() => this.employmentAccessService.isAccessGranted(Number(route.params.employmentId), route.data.allowedPermissions)));
  }
}
